import { createContext, useContext, useState } from "react";

const ConnectionContext = createContext<any>(null);

export const ConnectionProvider = ({ children }: any) => {
  const [resetConnection, setResetConnection] = useState(false);

  return (
    <ConnectionContext.Provider value={{ resetConnection, setResetConnection }}>
      {children}
    </ConnectionContext.Provider>
  );
};

export const useConnection = () => useContext(ConnectionContext);